/* eslint-disable class-methods-use-this */
import React, { Component } from 'react'
import { Pagination } from 'antd'
import Icon from 'meinian-package/src/component/icon'

import './index.less'

export default class Index extends Component {
  static defaultProps = {
    pageSize: 20,
    pageNo: 1,
    total: 0,
    showQuickJumper: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange() { }
  }

  onChange(pageNo) {
    this.props.onChange(pageNo)
  }

  renderPgn(page, type) {
    const { pageNo, total, pageSize } = this.props
    switch (type) {
      case 'prev':
        return <Icon type="m-Vxing_zuo" style={{ color: pageNo !== 1 ? 'var(--m-text-1)' : '', fontSize: 16 }} />
      case 'next':
        return <Icon type="m-Vxing_you" style={{ color: total / pageSize > pageNo ? 'var(--m-text-1)' : '', fontSize: 16 }} />
      case 'jump-prev':
        return <Icon type="m-gengduocaidan" style={{ fontSize: 16 }} />
      case 'jump-next':
        return <Icon type="m-gengduocaidan" style={{ fontSize: 16 }} />
      default:
        return <span>{page}</span>
    }
  }

  render() {
    const { pageNo, pageSize, total, showQuickJumper, showSizeChanger = false } = this.props
    return (
      <div className="meinian-pagination">
        <Pagination
          hideOnSinglePage
          showQuickJumper={showQuickJumper}
          defaultPageSize={pageSize}
          current={pageNo}
          itemRender={this.renderPgn.bind(this)}
          onChange={this.onChange.bind(this)}
          total={total}
          showSizeChanger={showSizeChanger}
        />
      </div>
    )
  }
}
